export const loaderColor = '#E9E9E9';
export const loaderBarColor = '#0066FF';
